/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  webpage,
  eventService,
  fileFactory,
  documentService,
  documentsService,
  actionService,
  uiService,
  mergeFieldsService,
  labelsService,
  DOCUMENT
) => {
  $scope.Model = {
    availableDocuments: [],
    availableFileLabels: [],
    documentsList: null,
    mergeFields: [],
    isMergeFieldsVisible: false,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  const loadDocuments = () => {
    webpage.pageTitle('Loading, please wait');
    $q.all([
      documentsService.getAvailable({ isActive: !$scope.Model.isArchive }),
      mergeFieldsService.getFields(true),
      labelsService.getAvailable({
        type: 'file',
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
    ])
      .then((data) => {
        // Set Model values
        const availableDocuments = data[0];
        const mergeFields = data[1];
        const availableFileLabels = data[2];
        $scope.Model.availableDocuments = availableDocuments;
        $scope.Model.mergeFields = mergeFields;
        $scope.Model.availableFileLabels = availableFileLabels;
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Document templates : Settings');
        $scope.Model.isReady = true;
      });
  };

  if ($rootScope.CurrentAccount.isAdministrator) {
    loadDocuments();
  }

  $scope.$on('documentDelete', () => {
    documentsService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.deleteDocument,
      $scope.Model.documentsList.removeData,
      'merge template(s)'
    );
  });

  $scope.$on('documentDuplicate', () => {
    documentsService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.readDocument,
      documentService.createDocument,
      $scope.Model.documentsList.setDataAppend,
      'name',
      ' copy',
      'merge template(s)'
    );
  });

  $scope.$on('documentActivate', () => {
    documentsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.updateDocument,
      $scope.Model.documentsList.removeData,
      'merge template(s)',
      true
    );
  });

  $scope.$on('documentArchive', () => {
    documentsService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.documentsList.getSelected(),
      documentService.updateDocument,
      $scope.Model.documentsList.removeData,
      'merge template(s)',
      false
    );
  });

  $scope.$on('documentRename', (e, $event) => {
    documentsService.clearCache();
    eventService.documentRename({
      event: $event,
      document: $scope.Model.documentsList.getSelected()[0]
    });
  });

  $scope.$on('documentAdd', (e, $event) => {
    documentsService.clearCache();
    eventService.documentAdd({ event: $event });
  });

  $scope.$on('documentMergeFields', () => {
    $scope.Model.isMergeFieldsVisible = true;
  });

  $scope.documentDownload = ($event, document) => {
    fileFactory
      .getDownloadUrl({
        url: DOCUMENT.API.DOWNLOAD,
        file: document.file,
        name: document.name
      })
      .then((downloadUrl) => {
        fileFactory.download(downloadUrl);
      });
  };

  $scope.documentPreview = ($event, data) => {
    eventService.filePreview({
      event: $event,
      file: data,
      type: 'templates'
    });
  };

  $scope.editPdf = ($event, data) => {
    $event.stopPropagation();
    $state.transitionTo('settings.documents-fill-pdf', { id: data.id });
  };

  $scope.previewPdf = ($event, document) => {
    $event.stopPropagation();
    uiService.toast({
      text: {
        p1: 'Downloading a sample of',
        p2: document.name,
        p3: 'Please wait while file is processing.'
      },
      progress: true
    });
    documentService.previewPdf({
      idDocument: document.id,
      name: document.name
    });
  };

  $scope.documentAdded = (documents) => {
    documentsService.clearCache();
    let isNew = false;
    const len = documents.length;
    for (let d = 0; d < len; d += 1) {
      const document = documents[d];
      if (document?.isNew) {
        isNew = true;
      }
      delete document.isNew;
    }

    if (isNew === true) {
      if (_.some(documents, { isActive: true }) !== $scope.Model.isArchive) {
        $scope.Model.documentsList.setDataAppend(documents);
      }
    } else {
      $scope.Model.documentsList.setDataReplace(documents);
    }
    if (documents.length === 1 && documents[0].fields.length) {
      $state.transitionTo('settings.documents-fill-pdf', { id: documents[0].id });
    }
  };

  $scope.documentRenamed = (documents) => {
    documentsService.clearCache();
    $scope.Model.documentsList.setDataReplace(documents);
  };

  $scope.documentLabelsSelect = ($event, document) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableFileLabels,
      selectedLabels: document.idLabels,
      data: document
    });
  };

  $scope.documentLabelsSelected = (selectedLabels, document) => {
    const doc = document;
    doc.idLabels = selectedLabels;
    documentsService.clearCache();
    $scope.Model.documentsList.setDataReplace(doc);
    documentService.updateDocument(doc);
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.documentsList = list;
    $scope.Model.watcher = $scope.$parent.$watch(
      'Model.childStateIsArchive',
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          $scope.Model.isArchive = newValue;
          $scope.Model.isReady = false;
          $scope.Model.watcher();
          loadDocuments();
        }
      }
    );
  };
};
